import Choices from 'choices.js'

const cmpSelectChoices = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element
    const isDisabled = element.getAttribute('disabled')
    const searchPlaceholder = element.getAttribute('search-placeholder')
    let identifier = element.getAttribute('data-identifier')
    let elementId = element.getAttribute('id')

    if(identifier == null) {
      let elementName = element.getAttribute('name')
      identifier = elementName ? elementName : elementId ? elementId : ""
    }
    
    if (isDisabled === null || isDisabled === 'false') {
      const searchBool = searchPlaceholder || false
      const options = {
        itemSelectText: null,
        position: 'bottom',
        searchEnabled: searchBool,
        searchPlaceholderValue: searchPlaceholder,
        shouldSort: false
      }
      const choices = new Choices(element, options)
      const choicesDiv = _.component.closest(".choices")
      if(choicesDiv) {
        choicesDiv.setAttribute('aria-label', `Click to view ${identifier} options from the dropdown below`)
        elementId = elementId ? elementId : "dropdown-list"
        choicesDiv.id = elementId;
        const choicesDropdownList = choicesDiv.querySelector(".choices__list--dropdown")
        if(choicesDropdownList)
          choicesDropdownList.setAttribute('aria-labelledby', elementId)
      }

      return choices
    }
  }
}

export default cmpSelectChoices
